import { FC, JSX } from 'react';
import { Grid } from '@mui/material';
// components
import SandCoatingForm from './Form';
// interfaces
import { SandCoatingFormProps } from 'interfaces';

const AddSandCoatingForm: FC<SandCoatingFormProps> = ({ loading, isEdit = false }): JSX.Element => {
  return (
    <Grid container spacing={2}>
      <Grid item lg={6} md={12}>
        <SandCoatingForm loading={loading} isEdit={isEdit} />
      </Grid>
    </Grid>
  );
};

export default AddSandCoatingForm;
